import { useIntl } from 'react-intl';

import {getDisplayMessages} from "@/configuration/lang/langSlice";
import { gaPush, TABLE_ACTION_BAR_ACTIONS, TABLE_ACTION_BAR_CATEGORY } from '@/configuration/setup/googleAnalytics';
import {useAppSelector} from "@/configuration/setup/hooks";
import { exportJsonTableToXLSX } from '@/utils/export/exportJsonTableToExcel/exportJsonTableToExcel';
import {
  exportOnlyTableResponseToPDFNew,
} from "@/utils/export/exportResponseToPDF/exportOnlyTableResponseToPDFNew";

const classes = {
  container: 'display-flex justify-content-end align-items-center gap-5 margin-y-10',
  textMedium: 'text-medium text-size-10 text-size-14-sm',
  button: 'btn btn-primary btn-link',
  excelIcon: 'rioglyph rioglyph-csv',
  pdfIcon: 'rioglyph rioglyph-pdf-file',
};

const texts = {
  exportDataTable: 'chatPage.chatActions.table.export.dataTable',
  excel: 'Excel',
  pdf: 'PDF',
};

type TableActionBarProps = {
  message: string;
};


enum EDownloadFormat {
    PDF = 'PDF',
    EXCEL ='Excel',
};

const TableActionBar = ({ message }: TableActionBarProps) => {
  const intl = useIntl();
  const displayMessages = useAppSelector(getDisplayMessages) ?? {};

  const handleDownload = async (format: EDownloadFormat) => {

    if (format === EDownloadFormat.EXCEL) {
      exportJsonTableToXLSX(message);
    } else if (format === EDownloadFormat.PDF) {
      await exportOnlyTableResponseToPDFNew(message, displayMessages);
    }

    gaPush({
      category: TABLE_ACTION_BAR_CATEGORY,
      action: format === EDownloadFormat.EXCEL ? TABLE_ACTION_BAR_ACTIONS.DOWNLOAD_EXCEL : TABLE_ACTION_BAR_ACTIONS.DOWNLOAD_PDF,
      label: `File Format: ${format}`,
    });
  };

  return (
    <div data-testid="downloadTableSection" className={classes.container}>
      <span className={classes.textMedium}>{intl.formatMessage({ id: texts.exportDataTable })}</span>
      <span className={classes.container}>
        <button data-testid="downloadTableAsExcel" type="button" className={classes.button} onClick={() => handleDownload(EDownloadFormat.EXCEL)}>
          <span className={classes.excelIcon} aria-hidden="true" />
          <span className="text-capitalize text-size-14">{texts.excel}</span>
        </button>
        <button data-testid="downloadTableAsPDF" type="button" className={classes.button} onClick={() => handleDownload(EDownloadFormat.PDF)}>
          <span className={classes.pdfIcon} aria-hidden="true" />
          <span className="text-capitalize text-size-10 text-size-14">{texts.pdf}</span>
        </button>
      </span>
    </div>
  );
};

export default TableActionBar;
